export default [
    {
        definition: 'The percentage of households in a given category that have one or more TTD conversion activities attributed to them in the past 100 days.',
        displayName: 'Conversion Rate'
    },
    {
        definition: 'The percent increase in conversion rate of households with ATV versus the control group.',
        displayName: 'Lift'
    },
    {
        definition: 'An audience segment that is based on IP address with less than 15 device IDs associated with it. Household audiences are used to extend targeting from a single device to all devices associated with a specific household.',
        displayName: 'Household'
    },
    {
        definition: 'Any conversion pixel that is fired from a device associated with a household is counted as a household conversion.',
        displayName: 'Household Conversion'
    },
    {
        definition: 'A household where one or more ATV ads ran in addition to one or more non-ATV ads within the past 100 days.',
        displayName: 'Households with ATV'
    },
    {
        definition: 'A household in which only non-ATV ads ran within the past 100 days.',
        displayName: 'Households without ATV'
    }
];



// WEBPACK FOOTER //
// ./src/constants/glossaries/ATVGlossary.js